import { Button, Col, Input, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { clone, endsWith, omit, reject, sortBy, values } from "lodash";
import numeral from "numeral";
import "./style.scss";
import {
  CATEGORY_VO_BOC_GOI,
  INSTALLMENT_KYMDAN,
  PROPERTY_TYPE,
} from "../../../common/constant";
import { useTranslation } from "react-i18next";
import {
  addSpace,
  checkSpecialMattress,
  excludeProperty,
} from "../../../shared/helpers";
import FoamModal from "../../foamModal";
import SizeModal from "../../sizeModal";

const ProductAttribute = (props: any) => {
  const {
    productDetail,
    productInfo,
    quantity,
    setQuantity,
    currentOption,
    handleChangeOption,
  } = props;
  const { t } = useTranslation();
  const [product, setProduct] = useState<any>(productDetail);
  const [options, setOptions] = useState<any>(
    product.props || product.product_prop_default
  );
  const size_prices = product.size_prices || product.product_size_prices;
  const productOption = JSON.stringify(
    product.props || product.product_prop_default
  );

  useEffect(() => {
    checkValueValid();
  }, []);

  const disableOptionOutStock = (options: any, curOption: any) => {
    const { product_inventories } = product;
    if (product.validate_inventory && product_inventories) {
      const optionProductFeature = options.find(
        (x: any) =>
          x.check_inventory_field == "product_feature_code" && x.check_inventory
      );
      const optProductSpec = options.find(
        (x: any) =>
          x.check_inventory_field == "product_spec_code" && x.check_inventory
      );
      if (optionProductFeature && optionProductFeature.values) {
        for (let i = 0; i < optionProductFeature.values.length; i++) {
          const value = optionProductFeature.values[i];
          let pf_inv = product_inventories.find(
            (x: any) => x.product_feature_code == value.value && x.quantity > 0
          );
          if (pf_inv) {
            value.isInStock = true;
          }
        }

        let optionSelect = optionProductFeature.values.find(
          (x: any) => x.value == curOption[`${optionProductFeature.code}`].value
        );
        if (optionSelect && !optionSelect.isInStock) {
          const valueInStock = optionProductFeature.values.find(
            (x: any) => x.isInStock == true
          );
          if (valueInStock) {
            curOption[optionProductFeature.code] = {
              ...curOption[optionProductFeature.code],
              ...valueInStock,
            };
          }
        }

        for (let i = 0; i < optionProductFeature.values.length; i++) {
          const value = optionProductFeature.values[i];
          if (
            curOption[`${optionProductFeature.code}`].value == value.value &&
            optProductSpec &&
            optProductSpec.values
          ) {
            for (let k = 0; k < optProductSpec.values.length; k++) {
              const _valueSpec = optProductSpec.values[k];
              if (_valueSpec) {
                const product_inventory = product_inventories.find(
                  (x: any) =>
                    x.product_feature_code == value.value &&
                    `|${_valueSpec.value}|`.indexOf(
                      `|${x.product_spec_code}|`
                    ) > -1 &&
                    x.quantity > 0
                );

                if (product_inventory) {
                  _valueSpec.isInStock = true;
                }
              }
            }

            let optionSpecSelect = optProductSpec.values.find(
              (x: any) => x.value == curOption[`${optProductSpec.code}`].value
            );
            if (optionSpecSelect && !optionSpecSelect.isInStock) {
              const valueSpecInStock = optProductSpec.values.find(
                (x: any) => x.isInStock == true
              );
              if (valueSpecInStock) {
                curOption[optProductSpec.code] = {
                  ...curOption[optProductSpec.code],
                  ...valueSpecInStock,
                };
              }
            }
          }
        }
      }
    }
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      if (!option.check_inventory) {
        for (let j = 0; j < option.values.length; j++) {
          const value = option.values[j];
          if (value) {
            value.isInStock = true;
          }
        }
      }
    }

    return options;
  };

  const checkValueValid = (_curOption?: any) => {
    let curOption = _curOption || currentOption;

    let options = sortBy(JSON.parse(productOption), ["position"]);

    let _options = sortBy(
      values(curOption).filter((v) => v.is_use),
      ["position"]
    );

    for (let i = 0; i < _options.length; i++) {
      const option = _options[i];

      const code = _options.reduce((_code, cur) => {
        return cur.code === option.code
          ? (_code += curOption[option.code].value)
          : (_code += cur.code);
      }, "");

      const diffCodeOptions = options.filter(
        (v) => v.code !== option.code && v.is_use
      );

      for (let j = 0; j < diffCodeOptions.length; j++) {
        const diffCodeOption = diffCodeOptions[j];

        options[
          options.findIndex((v) => v.code === diffCodeOption.code)
        ].values = diffCodeOption.values.map((v: any) => {
          let active = true;

          const codeReplaced = code.replace(diffCodeOption.code, v.value);

          if (
            size_prices.findIndex((sp: any) =>
              sp.value.includes(codeReplaced)
            ) < 0
          ) {
            active = false;
          }
          return {
            ...v,
            active,
          };
        });
      }
    }

    const productPrice = getPrice(curOption);

    const productCode = productPrice.code;

    options = options.map((v) => {
      // For Drap
      if (v.code === "LOAI") {
        const indexSize = options.findIndex((is) => is.code === "KICH-THUOC");
        const indexPattern = options.findIndex((ip) => ip.code === "HOA-VAN");
        const indexCover = options.findIndex((is) => is.code === "VO-BOC");

        const propType = v.values.findIndex(
          (vi: any) => vi.value === curOption["LOAI"].value
        );

        if (indexSize > -1 && propType > -1) {
          options[indexSize].values = JSON.parse(productOption)[
            indexSize
          ].values.filter(
            (ov: any) => v.values[propType].sizes.indexOf(ov.value) > -1
          );

          if (
            options[indexSize].values.findIndex(
              (ci: any) => ci.value === curOption[options[indexSize].code].value
            ) === -1
          ) {
            curOption[options[indexSize].code].value =
              options[indexSize].values[0].value;
            curOption[options[indexSize].code].label =
              options[indexSize].values[0].label;
          }
        }

        if (indexPattern > -1 && propType > -1) {
          options[indexPattern].values = JSON.parse(productOption)[
            indexPattern
          ].values.filter(
            (ov: any) => v.values[propType].patterns.indexOf(ov.value) > -1
          );

          if (
            options[indexPattern].values.findIndex(
              (ci: any) =>
                ci.value === curOption[options[indexPattern].code].value
            ) === -1
          ) {
            curOption[options[indexPattern].code] =
              options[indexPattern].values[0];
            // curOption[options[indexPattern].code].label =
            //   options[indexPattern].values[0].label;
            // curOption[options[indexPattern].code].img =
            //   options[indexPattern].values[0].img;
          }
        }

        if (indexCover > -1 && propType > -1) {
          options[indexCover].values = JSON.parse(productOption)[
            indexCover
          ].values.filter(
            (ov: any) => v.values[propType].covers.indexOf(ov.value) > -1
          );
          if (
            options[indexCover].values.findIndex(
              (ci: any) =>
                ci.value === curOption[options[indexCover].code].value
            ) === -1
          ) {
            curOption[options[indexCover].code].value =
              options[indexCover].values[0].value;
            curOption[options[indexCover].code].label =
              options[indexCover].values[0].label;
          }
        }
      } else if (v.code === "VO-BOC") {
        // For Giuong
        const indexSize = options.findIndex((is) => is.code === "KICH-THUOC");

        if (indexSize > -1) {
          options[indexSize].values = JSON.parse(productOption)[
            indexSize
          ].values.filter((ov: any) => {
            let cover = options.find((o) => o.code === "VO-BOC");

            if (
              cover &&
              cover.values &&
              cover.values.length &&
              cover.values[0].pf_prefix
            ) {
              return ov.value.includes(
                curOption["VO-BOC"].pf_prefix ||
                  cover.values.find(
                    (c: any) => c.value === curOption["VO-BOC"].value
                  )?.pf_prefix ||
                  cover.values[0].pf_prefix
              );
            }

            return endsWith(ov.value, curOption["VO-BOC"].value);
          });

          if (curOption["LOAI"] && curOption["LOAI"].value) {
            const indexType = options.findIndex((is) => is.code === "LOAI");
            if (indexType > -1) {
              const _sizes = options[indexType].values.filter((t: any) => {
                return t.value === curOption["LOAI"].value;
              })[0].sizes;
              options[indexSize].values = JSON.parse(productOption)[
                indexSize
              ].values.filter((ov: any) => {
                let cover = options.find((o) => o.code === "VO-BOC");

                if (
                  cover &&
                  cover.values &&
                  cover.values.length &&
                  cover.values[0].pf_prefix
                ) {
                  return (
                    ov.value.includes(
                      curOption["VO-BOC"].pf_prefix ||
                        cover.values.find(
                          (c: any) => c.value === curOption["VO-BOC"].value
                        )?.pf_prefix ||
                        cover.values[0].pf_prefix
                    ) && _sizes.includes(ov.value)
                  );
                }

                return (
                  endsWith(ov.value, curOption["VO-BOC"].value) &&
                  _sizes.includes(ov.value)
                );
              });
            }
          }

          if (
            options[indexSize].values.findIndex(
              (ci: any) => ci.value === curOption[options[indexSize].code].value
            ) === -1
          ) {
            curOption[options[indexSize].code].value =
              options[indexSize].values[0].value;
            curOption[options[indexSize].code].label =
              options[indexSize].values[0].label;
          }
        }
      }
      return v;
    });

    options = reject(options, (v) => {
      const checkSpec = excludeProperty(
        size_prices.find((t: any) =>
          productDetail?.cat_id == CATEGORY_VO_BOC_GOI
            ? t.value == productCode
            : t.value.includes(productCode)
        ).exc_spec_ids,
        v.id
      );

      if (checkSpec) {
        curOption = omit(curOption, [v.code]);
      } else if (
        curOption[v.code] === undefined ||
        curOption[v.code] === null
      ) {
        const excludeValue = v.values.find(
          (p: any) => !excludeProperty(productCode.exc_spec_value_ids, p.value)
        );

        curOption[v.code] = {
          code: v.code,
          title: v.label,
          value: excludeValue.value,
          label: excludeValue.label,
          is_use: v.is_use,
          position: v.position,
          img: v.img,
          type: v.type,
        };
      }
      return checkSpec;
    });

    options = disableOptionOutStock(options, curOption);

    setOptions(options);
    handleChangeOption(curOption);
  };

  useEffect(() => {
    if (currentOption["HOA-VAN"]) {
      const pattern = currentOption["HOA-VAN"];
      if (pattern.img) {
        let _product = clone(product);
        _product.img = pattern.img;
        setProduct(_product);
      }
    }
  }, [options, currentOption]);

  const onChangeOption = (option: any) => {
    let _options = omit(option, ["values"]);
    const _curOption = { ...currentOption };

    _curOption[_options.code] = {
      ..._curOption[_options.code],
      ..._options,
    };

    checkValueValid(_curOption);
  };

  const getPrice = (_curOption: any) => {
    let rs = {};

    let curOption = _curOption || currentOption;

    const _options = values(sortBy(curOption, ["position"]));
    const code = _options.reduce((prev, curr) => {
      let _prev = prev || "";
      if (curr.is_use) {
        _prev += curr.value;
      }
      return _prev;
    }, "");
    const checkPrice = size_prices.find((v: any) => v.value.includes(code));
    let full_code = null;
    if (checkPrice) {
      rs = checkPrice;
      full_code = checkPrice.value;
    }

    return { ...rs, code, full_code };
  };

  const showSizeModal = (attr: any) => {
    const featureValue = attr.values.find(
      (v: any) =>
        v.value === currentOption[attr.code].value &&
        v.feature_size_images &&
        v.feature_size_images.length
    );

    if (!featureValue) return;

    const sizeImages = featureValue.feature_size_images;

    return (
      <SizeModal sizeImages={sizeImages} productName={productDetail.name} />
    );
  };

  const hiddenSizeSpec = () => {
    const productProps = productDetail?.props;

    if (!productProps || !productProps.length) {
      return false;
    }

    const size = productProps.find(
      (item: any) => item.code === PROPERTY_TYPE.size_drap
    );

    if (!size) {
      return false;
    }

    return !!size?.is_hidden;
  };

  const showAttributes = () => {
    return (
      currentOption &&
      options.length &&
      options
        .filter((attribute: any) => {
          if (attribute.code === PROPERTY_TYPE.size_drap && hiddenSizeSpec()) {
            return false;
          }
          return true;
        })
        .map((attribute: any, index: number) => (
          <Row
            key={index}
            align="middle"
            // justify="space-between"
            className="product-attribute-item-wrapper">
            <Col>
              <Row align="middle">
                <Col className="main-content attribute-title">
                  {attribute.code == PROPERTY_TYPE.foam && <FoamModal />}
                  {showSizeModal(attribute)}

                  {attribute.label
                    .replace(" rộng x dài", "")
                    .replace("Cao (độ dày)", "Độ dày nệm")
                    .replace("(density) foam", "mousse nệm")}
                </Col>
                {/* <Col>
              
              </Col> */}
              </Row>

              {attribute.code == PROPERTY_TYPE.size ? (
                <Row align="middle">
                  <Col className="attribute-title attribute-sub-title">
                    (ngang x dọc, cm)
                  </Col>
                </Row>
              ) : attribute.code == PROPERTY_TYPE.thick ? (
                <Row align="middle">
                  <Col className="attribute-title attribute-sub-title">
                    (cm)
                  </Col>
                </Row>
              ) : null}
            </Col>
            <Col
              //  span={12}
              className="product-attribute-value">
              <Row align="middle">
                <Select
                  value={currentOption[attribute.code].value}
                  style={{ width: "100%" }}
                  onChange={(value: any) => {
                    const option = attribute.values.find(
                      (v: any) => v.value === value
                    );
                    onChangeOption({ ...attribute, ...omit(option, ["code"]) });
                  }}
                  dropdownClassName={`${
                    attribute.code === PROPERTY_TYPE.image
                      ? "min-widht-350"
                      : ""
                  } attribute-dropdown-option-wrap`}
                  className={
                    attribute.code !== PROPERTY_TYPE.image
                      ? "attribute-select-text-wrap"
                      : "attribute-select-image-wrap"
                  }>
                  {attribute.values &&
                    attribute.values.length &&
                    showValuesAttribute(attribute)}
                </Select>
              </Row>
            </Col>
          </Row>
        ))
    );
  };

  const showValuesAttribute = (attribute: any) => {
    // let values =
    //   attribute.code === PROPERTY_TYPE.image
    //     ? _.orderBy(attribute.values, "isInStock")
    //     : attribute.values;
    const values = attribute.values;

    return values.map(
      (item: any, i: number) =>
        // item.active === true ||
        item.isInStock && (
          <Select.Option
            disabled={item.active === false || !item.isInStock}
            value={item.value}
            className={`attribute-select-option-wrap ${
              attribute.code !== PROPERTY_TYPE.image
                ? ""
                : "attribute-select-option-wrap-pattern"
            }`}>
            {attribute.code !== PROPERTY_TYPE.image ? (
              <>{addSpace(item.label)}</>
            ) : (
              <>
                <div className="attribute-select-item-wrap">
                  <img src={item.img} alt="" />
                  {/* {!item.isInStock && (
                    <div className="attribute-select-item-out-stock">
                      <span>Tạm hết</span>
                    </div>
                  )} */}
                </div>

                <span>{item.label}</span>
              </>
            )}
          </Select.Option>
        )
    );
  };

  const handleChangeQuantity = (value: number) => {
    if (!isNaN(value)) {
      if (value > 100) {
        value = 100;
      }

      if (value >= 1 && value <= 100) {
        setQuantity(value);
      }
    }
  };

  const onClickCountUp = () => {
    if (quantity < 100) {
      setQuantity(quantity + 1);
    }
  };
  const onClickCountDown = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  return product ? (
    <Row align="middle" justify="end" className="product-attribute-wrapper">
      <Col span={24}>
        {showAttributes()}
        <Row
          align="middle"
          justify="space-between"
          className="product-attribute-item-wrapper">
          <Col>
            <Row align="middle">
              <Col className="main-content attribute-title">Số lượng</Col>
            </Row>
          </Col>
          <Col className="product-attribute-value">
            <Row align="middle">
              <Input
                type={"number"}
                defaultValue={quantity}
                value={quantity}
                min={1}
                max={100}
                onChange={(e) => handleChangeQuantity(parseInt(e.target.value))}
                className={"input-quantity-wrap"}
                addonAfter={
                  <Button
                    className="input-quantity-count-up"
                    disabled={quantity === 100}
                    onClick={() => onClickCountUp()}>
                    +
                  </Button>
                }
                addonBefore={
                  <Button
                    className="input-quantity-count-down"
                    disabled={quantity === 1}
                    onClick={() => onClickCountDown()}>
                    -
                  </Button>
                }
              />
            </Row>
          </Col>
        </Row>

        <Row
          align="middle"
          justify="space-between"
          className="product-attribute-item-wrapper price-property"
          style={{ marginTop: 10 }}>
          <Col>
            <Row align="middle">
              <Col className="main-content price-title">ĐƠN GIÁ</Col>
            </Row>
          </Col>
          <Col>
            <Row align="middle">
              <Col
                flex="auto"
                className="price-value price-promotion--red price-installment">
                {productInfo.price_promotion}
              </Col>
              <Col className="currency-unit-wrap">
                {t("label_currency_unit")}
              </Col>
            </Row>
          </Col>
        </Row>
        {!checkSpecialMattress(
          productInfo.price,
          productInfo.price_promotion
        ) && (
          <Row
            align="middle"
            justify="space-between"
            className="product-attribute-item-wrapper price-property">
            <Col>
              <Row align="middle">
                <Col className="main-content price-title price-title--normal">
                  Giá niêm yết
                </Col>
              </Row>
            </Col>
            <Col>
              <Row align="middle">
                <Col flex="auto" className="sub-title price-retail">
                  &nbsp;{productInfo.price}&nbsp;
                </Col>
                <Col className="currency-unit-wrap">
                  {t("label_currency_unit")}
                </Col>
                <Col className="main-cotent">
                  <span className="discount-percent">
                    -{productInfo.discount_percent}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        )}

        {productInfo.price_installment !== 0 && (
          <Row
            align="middle"
            justify="space-between"
            className="product-attribute-item-wrapper price-property">
            <Col>
              <Row align="middle">
                <Col className="main-content price-title price-installment-title">
                  <div className="price-installment-title-wrap">
                    <a href={INSTALLMENT_KYMDAN} target="_blank">
                      {t("label_installment")}
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row align="middle">
                <Col flex="auto" className="price-value price-installment">
                  {productInfo.price_installment}
                </Col>
                <Col className="currency-unit-wrap">
                  {`${t("label_currency_unit")} /${t("label_month_unit")}`}
                </Col>
              </Row>
            </Col>
          </Row>
        )}

        <Row
          // align="middle"
          justify="space-between"
          className="product-attribute-item-wrapper total-amount">
          <Col className="sub-title price-title">
            {t("label_total_amount")}
            <Row
              justify="end"
              className="sub-content"
              style={{
                color: "#ffffff",
                textTransform: "none",
                fontWeight: 200,
              }}>
              (Giá đã bao gồm VAT)
            </Row>
          </Col>
          <Col>
            <Row align="middle">
              <Col flex="auto" className="price-value">
                {numeral(quantity * productInfo.price_promotion_type_number)
                  .format("0,0")
                  .replaceAll(",", ".")}
              </Col>
              <Col className="currency-unit-wrap">
                {t("label_currency_unit")}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  ) : null;
};

export default ProductAttribute;
